import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { copyToClipboard } from '../../actions/utils';
import { textCss } from '../../common/Css';
import IconToolTip from '../../common/IconToolTip';
import { goToUserDocuments } from './TeamController';
import ModifyNotificationSettings from '../chat/sidedrawer/Components/ModifyNotificationSettings';
import CoversationMedia from '../chat/sidedrawer/Media';
import { useMemo } from 'react';
import { convertIntoRupee } from '../../utils/utils';
import { TicketAgentRole } from '../Ticket/TicketController';


const getAllCityLocationsInString = ({ territories }) => {
    if (Array.isArray(territories)) {
        return territories
            .filter((territory) => territory.name)
            .map((territory) => territory.name)
            .join(', ');
    }
    return '';
};

export const UserDetails = ({
    profile_pic,
    userName,
    email,
    SPName,
    refferalCode,
    mobile,
    address,
    documentFolderId,
    territories,
    tags,
    bankDetails,
    selectedConversationId,
    showMedia = false,
    showModifyNotificationSettings = false,
    sendNotificationsFor,
    setShowMedia,
    storeAffiliateLink,
    userDetails,
    kyc,
    is_kyc_verified,
    walletDetails,
    roles = []
}) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isSpNameIsSameAsName = SPName === userName;

    const OnCopyReferralCode = (referralCode) => {
        if (referralCode) {
            dispatch(copyToClipboard({ data: referralCode }));
        }
    };

    const isBankDetails = bankDetails && Object.keys(bankDetails).length > 0;

    return (
        <div className='h-full pb-8 overflow-y-auto '>
            <div className='border-t border-scogogray pt-5'>
                <div className=''>
                    <img src={profile_pic} className='w-24 h-24 rounded-full mx-auto object-cover' alt='' />
                </div>
                <p className={`text-center mt-m-15 ${textCss.headerOne}`}>{userName ? userName.replace(/\s*\[BLANK\]\s*/, '') : ''}</p>

                {refferalCode && (
                    <p className={`justify-center gap-2 flex items-center ${textCss.headerThree}`}>
                        Referral Code{' '}
                        <span className='bg-scogo99 rounded-lg flex items-center gap-2 px-2 py-1'>
                            <span onClick={() => OnCopyReferralCode(refferalCode)} className='material-icons text-lg cursor-pointer'>
                                content_copy
                            </span>{' '}
                            {refferalCode}
                        </span>
                    </p>
                )}
            </div>

            <div className='mt-2'>
                <div className='p-6 border-t-10 bg-white rounded-lg shadow-sm'>
                    {SPName && !isSpNameIsSameAsName && (
                        <div className='py-3 flex items-center gap-4 border-b border-gray-100'>
                            <span className='material-icons text-scogoprimary'>business</span>
                            <div>
                                <p className='text-sm text-gray-500'>Service Partner</p>
                                <p className='text-md text-scogo99'>{SPName}</p>
                            </div>
                        </div>
                    )}
                    {email && (
                        <div className='py-3 flex items-center gap-4 border-b border-gray-100'>
                            <span className='material-icons text-scogoprimary'>email</span>
                            <div>
                                <p className='text-sm text-gray-500'>Email</p>
                                <p className='text-md text-scogo99'>{email}</p>
                            </div>
                        </div>
                    )}
                    {mobile && (
                        <div className='py-3 flex items-center gap-4 border-b border-gray-100'>
                            <span className='material-icons text-scogoprimary'>phone_iphone</span>
                            <div>
                                <p className='text-sm text-gray-500'>Mobile</p>
                                <p className='text-md text-scogo99'>{mobile}</p>
                            </div>
                        </div>
                    )}
                    {address && (
                        <div className='py-3 flex items-center gap-4 border-b border-gray-100'>
                            <span className='material-icons text-scogoprimary'>place</span>
                            <div>
                                <p className='text-sm text-gray-500'>Address</p>
                                <p className='text-md text-scogo99'>{address}</p>
                            </div>
                        </div>
                    )}

                    <RenderWalletDetails walletDetails={walletDetails} roles={roles} />

                    <RenderKyc kyc={kyc} is_kyc_verified={is_kyc_verified} />

                    {storeAffiliateLink && (
                        <div className='py-3 flex items-center gap-4'>
                            <span className='material-icons text-scogoprimary'>link</span>
                            <div className='flex-1'>
                                <p className='text-xs text-gray-500'>Affiliate Link</p>
                                <div className='flex items-center gap-2'>
                                    <p className='text-sm text-sky-500 break-all'>{storeAffiliateLink}</p>
                                    <IconToolTip title={'Copy Affiliate Link'}>
                                        <span
                                            className='material-icons text-scogobgsky hover:text-scogoorange text-font15 cursor-pointer transition-colors'
                                            onClick={() => {
                                                dispatch(copyToClipboard({ data: storeAffiliateLink }));
                                            }}
                                        >
                                            content_copy
                                        </span>
                                    </IconToolTip>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {showModifyNotificationSettings && (
                    <div className='border-t-10 p-5'>
                        <ModifyNotificationSettings sendNotificationsFor={sendNotificationsFor} conversationId={selectedConversationId} mainDivClass='p-2' />
                    </div>
                )}

                {showMedia && (
                    <div className='border-t-10 p-5'>
                        <CoversationMedia setShowMedia={setShowMedia} />
                    </div>
                )}
                {documentFolderId && (
                    <div className='border-t-10 p-5'>
                        <div className='mt-2 py-2 text-font12 flex gap-4 items-center'>
                            <p className='font-medium text-scogoprimary'>Documents</p>
                            <IconToolTip title='Documents'>
                                <span
                                    className='material-icons hover:text-scogoorange cursor-pointer'
                                    onClick={() => goToUserDocuments({ document_folder_id: documentFolderId, navigate })}
                                >
                                    folder
                                </span>
                            </IconToolTip>
                        </div>
                    </div>
                )}
                <div className='border-t-10 p-5'>
                    {Array.isArray(territories) && territories.length > 0 && (
                        <div className='py-2 text-font12  mt-2'>
                            <p className='font-medium text-scogoprimary'>Locations</p>
                            <p className='text-scogo99'>
                                {getAllCityLocationsInString({
                                    territories,
                                })}
                            </p>
                        </div>
                    )}
                    {tags && tags.length > 0 && <RenderTags tags={tags} />}
                </div>

                {isBankDetails && (
                    <div className='border-t-10 p-5'>
                        {bankDetails.holder_name || bankDetails.account_holder_name && (
                            <div className='py-2 text-font12'>
                                <p className='font-medium text-scogoprimary'>Account Holder Name</p>
                                <p className='text-scogo99'>{bankDetails.holder_name || bankDetails.account_holder_name}</p>
                            </div>
                        )}
                        {bankDetails.bank || bankDetails.bank_name && (
                            <div className='py-2 text-font12'>
                                <p className='font-medium text-scogoprimary'>Bank Name</p>
                                <p className='text-scogo99'>{bankDetails.bank || bankDetails.bank_name}</p>
                            </div>
                        )}
                        {bankDetails.acc_num || bankDetails.account_number && (
                            <div className='py-2 text-font12'>
                                <p className='font-medium text-scogoprimary'>Account Number</p>
                                <p className='text-scogo99'>{bankDetails.acc_num || bankDetails.account_number}</p>
                            </div>
                        )}
                        {/* {bankDetails.acc_type || bankDetails.acc_type && (
                            <div className='py-2 text-font12'>
                                <p className='font-medium text-scogoprimary'>Account Type</p>
                                <p className='text-scogo99'>{bankDetails.acc_type || bankDetails.acc_type}</p>
                            </div>
                        )} */}
                        {bankDetails.ifsc || bankDetails.ifsc_code && (
                            <div className='py-2 text-font12'>
                                <p className='font-medium text-scogoprimary'>IFSC Code</p>
                                <p className='text-scogo99'>{bankDetails.ifsc || bankDetails.ifsc_code}</p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};



const RenderTags = ({ tags }) => {

    const groupedByTagTypes = useMemo(() => {
        let initialValue = { TOOL: [], USECASE: [], CUSTOM: [] };

        return tags.reduce((acc, item) => {
            const { tag_type } = item;
            if (!tag_type) {
                acc.CUSTOM.push(item);
            } else if (acc.hasOwnProperty(tag_type)) {
                acc[tag_type].push(item);
            }
            return acc;
        }, initialValue);
    }, [tags]);

    return (
        <div className='py-2 text-font12 '>
            {Object.keys(groupedByTagTypes).map((tagType) => (
                <div key={tagType} className='py-2'>
                    <p className='font-medium text-scogoprimary'>{tagType === 'CUSTOM' ? 'Custom Tags' : tagType}</p>
                    <p className='text-scogo99'>
                        {groupedByTagTypes[tagType].map(({ text }) => text).join(', ')}
                    </p>
                </div>
            ))}
        </div>
    )
}

const RenderWalletDetails = ({ walletDetails, roles }) => {
    const formatAmount = (amountInPaisa) => {
        if (!amountInPaisa && amountInPaisa !== 0) return '0.00';
        const rupees = convertIntoRupee(amountInPaisa);
        return rupees.toFixed(2);
    };

    const isClusterOrPspUser = roles.find(({ role }) => [TicketAgentRole.CLUSTER.toUpperCase(), TicketAgentRole.PSP.toUpperCase()].includes(role.label.toUpperCase()));

    if (!walletDetails) return null;

    return (
        <div className="py-3 border-b border-gray-100 mb-2">
            <p className="font-medium text-scogoprimary text-[15px] mb-2">Wallet Details</p>
            <div className='flex flex-wrap gap-2'>
                <div className='inline-flex items-center px-4 py-2 rounded-full bg-blue-100 border border-blue-200'>
                    <span className='text-sm font-medium text-blue-800 select-none'>Balance:</span>
                    <span
                        title="Click to copy" onClick={() => {
                            navigator.clipboard.writeText(walletDetails.balance?.toString());
                        }}
                        className='ml-2 text-sm font-semibold text-blue-900 cursor-pointer select-none'>₹{formatAmount(walletDetails.balance)}</span>
                </div>
                {isClusterOrPspUser && (
                    <>
                        <div className='inline-flex items-center px-4 py-2 rounded-full bg-green-100 border border-green-200'>
                            <span className='text-sm font-medium text-green-800 select-none'>Incentive:</span>
                            <span title="Click to copy" onClick={() => {
                                navigator.clipboard.writeText(walletDetails.incentive?.toString());
                            }}
                                className='ml-2 text-sm font-semibold text-green-900 cursor-pointer select-none'>₹{formatAmount(walletDetails.incentive)}</span>
                        </div>
                        <div className='inline-flex items-center px-4 py-2 rounded-full bg-amber-100 border border-amber-200'>
                            <span className='text-sm font-medium text-amber-800 select-none'>Locked:</span>
                            <span title="Click to copy" onClick={() => {
                                navigator.clipboard.writeText(walletDetails.locked?.toString());
                            }}
                                className='ml-2 text-sm font-semibold text-amber-900 cursor-pointer select-none'>₹{formatAmount(walletDetails.locked)}</span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

const RenderKyc = ({ kyc, is_kyc_verified }) => {
    const groupedKyc = useMemo(() => {
        return kyc?.reduce((acc, item) => {
            const { ref, label, value, files, is_verified } = item;
            if (!acc[ref]) {
                acc[ref] = {
                    label,
                    value,
                    files,
                    is_verified,
                };
            }
            return acc;
        }, {});
    }, [kyc]);

    return (
        <div className="py-2">
            <div className="flex items-center justify-between mb-4">
                <p className="font-medium text-scogoprimary text-[15px]">KYC Details</p>
                {is_kyc_verified !== undefined && (
                    <div className={`px-3 py-1 rounded-full text-font10 ${is_kyc_verified ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                        Link Status: {is_kyc_verified ? 'Linked' : 'Not Linked'}
                    </div>
                )}
            </div>
            <div className="space-y-4">
                {groupedKyc && Object.entries(groupedKyc).map(([key, details]) => (
                    <div key={key} className="border border-gray-200 rounded-md p-4">
                        <div className="flex items-center justify-between mb-2">
                            <p className="font-medium text-scogoprimary text-font12">{details.label}</p>
                        </div>
                        <p className="text-scogo99 text-font12 mb-2">{details.value}</p>

                        {details.files?.length > 0 && (
                            <div className="mt-2">
                                <p className="text-scogoprimary text-font11 mb-2">Attachments:</p>
                                <div className="flex flex-wrap gap-2">
                                    {details.files.map((file, index) => {
                                        const isValidLink = file.link && (file.link.startsWith('http://') || file.link.startsWith('https://'));

                                        return isValidLink ? (
                                            <a
                                                key={index}
                                                href={file.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="inline-flex items-center px-3 py-1 rounded-full text-font11 text-gray-700 hover:bg-gray-200"
                                            >
                                                <span>{file.label}</span>
                                                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                                </svg>
                                            </a>
                                        ) : (
                                            <div
                                                key={index}
                                                className={`inline-flex items-center px-3 py-1 rounded-full text-font11 ${file.link === 'masked' ? 'text-red-700 bg-red-100' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} s
                                            >
                                                <span>{file.label}</span>
                                                {file.link === 'masked' ? <span className="ml-1 text-font10">(View Not Allowed)</span> : null}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div >
    );
};
